import { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";

// /new-music — music-alert signup. Same subscriber backend (/api/subscribe)
// with source="new-music" + interest="new-music" so it can be segmented later.
export default function NewMusic() {
  const API = process.env.REACT_APP_BACKEND_URL;
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState(null); // null | 'loading' | 'ok' | 'error'
  const [errMsg, setErrMsg] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !email.includes("@")) { setStatus("error"); setErrMsg("Please enter a valid email."); return; }
    setStatus("loading");
    try {
      const res = await fetch(`${API}/api/subscribe`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, source: "new-music", interest: "new-music" }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data?.detail || "Please try again.");
      setStatus("ok");
    } catch (err) {
      setStatus("error");
      setErrMsg(err.message || "Something went wrong.");
    }
  };

  return (
    <div className="App bg-black text-white min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 flex items-center justify-center px-4 md:px-10 pt-28 md:pt-36 pb-16 md:pb-24">
        <div className="w-full max-w-xl text-center">
          <div className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#F4C10A] mb-4">
            Philadelphia Freeway · FTA
          </div>
          <h1
            data-testid="new-music-heading"
            className="font-wide uppercase text-5xl sm:text-6xl md:text-7xl leading-[0.95]"
          >
            New Music
          </h1>
          <p className="mt-5 md:mt-6 font-body text-white/80 text-base md:text-lg leading-relaxed">
            Stay tapped in. Be one of the first to know when new Freeway music drops.
          </p>

          {status === "ok" ? (
            <div
              data-testid="new-music-success"
              className="mt-10 border border-[#F4C10A]/50 bg-black text-white p-6"
            >
              <div className="font-wide uppercase text-xl text-[#F4C10A]">You're on the list</div>
              <div className="mt-2 font-mono text-[11px] tracking-[0.2em] text-white/70">
                We'll be in your inbox the moment the next drop lands.
              </div>
            </div>
          ) : (
            <form
              onSubmit={submit}
              data-testid="new-music-form"
              className="mt-10 flex flex-col gap-3 items-stretch"
            >
              <input
                type="email"
                required
                autoComplete="email"
                data-testid="new-music-email"
                placeholder="Your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-transparent border border-white/25 focus:border-[#F4C10A] outline-none px-4 py-3.5 text-white placeholder-white/40 font-mono text-sm tracking-wide"
              />
              <button
                type="submit"
                data-testid="new-music-cta"
                disabled={status === "loading"}
                className="w-full bg-[#F4C10A] text-black font-display uppercase text-sm tracking-[0.24em] py-4 hover:bg-white transition-colors disabled:opacity-50"
              >
                {status === "loading" ? "Submitting…" : "Subscribe for New Music"}
              </button>
              {status === "error" && (
                <div data-testid="new-music-error" className="text-red-400 text-sm">{errMsg}</div>
              )}
            </form>
          )}

          <div className="mt-6 font-mono text-[10px] tracking-[0.25em] uppercase text-white/40">
            By subscribing you agree to our{" "}
            <Link to="/privacy" className="underline hover:text-[#F4C10A]" data-testid="new-music-privacy">
              Privacy Policy
            </Link>
            .
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
